(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slide-section"] && !Shopify.designMode) return;
  try {
    
function initCrewCarousel(sectionEl) {
  if (!sectionEl) return;

  const crewCards = Array.from(sectionEl.querySelectorAll(".crew-card"));
  const crewDots = Array.from(sectionEl.querySelectorAll(".crew-dot"));
  const crewName = sectionEl.querySelector(".crew-name");
  const crewRole = sectionEl.querySelector(".crew-role");
  const leftBtn = sectionEl.querySelector(".crew-left");
  const rightBtn = sectionEl.querySelector(".crew-right");

  if (!crewCards.length) return;

  const crewMembers = crewCards.map((card) => ({
    name: card.querySelector("img")?.alt || "Crew Member",
    role: card.dataset.role || ""
  }));

  let crewIndex = 0;
  let crewAnimating = false;

  const total = crewCards.length;

  function wrapIndex(index) {
    return (index + total) % total;
  }

  function updateCrewCarousel(newIndex) {
    if (crewAnimating) return;
    crewAnimating = true;

    crewIndex = wrapIndex(newIndex);
    const visibleCards = total <= 3 ? total : 5;

    crewCards.forEach((card, i) => {
  card.classList.remove("center", "left-1", "right-1", "left-2", "right-2", "hidden");

  // calculate distance from current index
  let distance = i - crewIndex;

  // wrap distances
  if (distance < -Math.floor(total / 2)) distance += total;
  if (distance > Math.floor(total / 2)) distance -= total;

  if (visibleCards <= 3) {
    if (distance === 0) card.classList.add("center");
    else if (distance === 1) card.classList.add("right-1");
    else if (distance === -1) card.classList.add("left-1");
    else card.classList.add("hidden");
  } else {
    if (distance === 0) card.classList.add("center");
    else if (distance === 1) card.classList.add("right-1");
    else if (distance === 2) card.classList.add("right-2");
    else if (distance === -1) card.classList.add("left-1");
    else if (distance === -2) card.classList.add("left-2");
    else card.classList.add("hidden");
  }
});


    crewDots.forEach((dot, i) => dot.classList.toggle("active", i === crewIndex));

    if (crewName && crewRole && crewMembers[crewIndex]) {
      crewName.style.opacity = "0";
      crewRole.style.opacity = "0";
      setTimeout(() => {
        crewName.textContent = crewMembers[crewIndex].name;
        crewRole.textContent = crewMembers[crewIndex].role;
        crewName.style.opacity = "1";
        crewRole.style.opacity = "1";
      }, 300);
    }

    setTimeout(() => (crewAnimating = false), 700);
  }

  leftBtn?.addEventListener("click", () => updateCrewCarousel(crewIndex - 1));
  rightBtn?.addEventListener("click", () => updateCrewCarousel(crewIndex + 1));

  crewDots.forEach((dot, i) => dot.addEventListener("click", () => updateCrewCarousel(i)));

  let touchStartX = 0;
  sectionEl.addEventListener("touchstart", (e) => (touchStartX = e.touches[0].clientX));
  sectionEl.addEventListener("touchend", (e) => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? updateCrewCarousel(crewIndex + 1) : updateCrewCarousel(crewIndex - 1);
    }
  });

  updateCrewCarousel(0);
}

document.addEventListener("DOMContentLoaded", () =>
  document.querySelectorAll(".crew-section").forEach(initCrewCarousel)
);
document.addEventListener("shopify:section:load", (e) => {
  const section = e.target.querySelector(".crew-section");
  if (section) initCrewCarousel(section);
});

  } catch(e) { console.error(e); }
})();
})();
